import { ApprovedCollection } from '../../../api/collections';
import DSBox from '../../../design-system/DSBox';
import { COLLECTION_COVER_BORDER_RADIUS } from '../../../design-system/Collection';
import { DSTypography } from '../../../design-system/Typography';
import { useTheme } from '@mui/material';

interface CollectionCodeCardProps {
  collection: ApprovedCollection;
  code: string;
}

const CollectionCodeCard = ({ collection, code }: CollectionCodeCardProps) => {
  const { spacing } = useTheme();

  return (
    <DSBox
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {/* Collection Cover Image - displayed directly */}

      <img
        src={collection.coverUrl}
        alt={collection.name}
        style={{
          width: '100%',
          height: 'auto',
          display: 'block',
          borderRadius: COLLECTION_COVER_BORDER_RADIUS,
        }}
      />

      {/* Collection Name and Code - simple text below image */}
      <DSBox
        sx={{
          marginTop: spacing(2),
          textAlign: 'center',
        }}
      >
        <DSTypography
          sx={{
            color: '#000000',
            fontFamily: 'Gilroy, sans-serif',
            fontWeight: 600,
            fontSize: '16px',
            marginBottom: spacing(0.5),
          }}
        >
          {collection.name}
        </DSTypography>

        <DSTypography
          sx={{
            color: '#333333',
            fontFamily: 'Gilroy, sans-serif',
            fontSize: '18px',
            fontWeight: 700,
            letterSpacing: '0.5px',
          }}
        >
          {code}
        </DSTypography>
      </DSBox>
    </DSBox>
  );
};

export default CollectionCodeCard;
